import React, { FC, useState } from "react";
import Card19 from "components/Card19/Card19";
import Card18 from "components/Card18/Card18";
import cogoToast from "cogo-toast"
import { useNavigate } from "react-router-dom"
import { BACKEND_URL } from "constants"
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import Input from "components/Input/Input"

// export interface SectionMagazine10Props extends SectionMagazine1Props {}

const SectionMagazineVideos = ({
  videos,
  className = "",
}) => {
  const navigate = useNavigate()
  const [itemOffset, setItemOffset] = useState(5);
  const [newYoutube, setNewYoutube] = useState("")
  const [loading, setLoading] = useState(false)
  const [mode,setMode] = useState(false)
  const endOffset = itemOffset + 12;

  const onDelete = (id) => {
    setTimeout(() => {
      fetch(`${BACKEND_URL}/delete_videos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: id
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            cogoToast.success("Wideo zostało usunięte");
            window.location.reload()
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, [2000]);
  }
const onEdit = async (item) => {
    setLoading(true)
    setTimeout(() => {
      fetch(`${BACKEND_URL}/youtube_videos`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          id: item.id,
          youtube_id: newYoutube
        }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.statusCode === 200) {
            cogoToast.success("Wideo zostało zaaktualizowane");
            setLoading(false)
            window.location.reload()
          } 
        })
        .catch((error) => console.error("error: ", error));
    }, [2000]);
  };
  return (
    <div className={`nc-SectionMagazine10 ${className}`}>
      {!videos.length && <span>Nic nie znaleziono!</span>}
      <div className="grid grid-cols-1 xl:grid-cols-4 gap-5">
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 sm:grid-rows-5 gap-5"> */}
          {videos
            .map((item, index) => {
              return(
                <div style={{display:'flex', flexFlow:"column"}} key={item.id}>
                  <span>{item.section_name || "Brak"}</span>
                  <h3 style={{marginBottom:'20px', fontSize:'20px'}}>{item.article_title}</h3>
                <LiteYouTubeEmbed
                  // showCategories={false}
                  id={item?.youtube_id}
                  title="YouTube video"
                />
              <div style={{display:"flex", flexFlow:"column", justifyContent:"space-between"}}>
              <button onClick={() => onDelete(item.id)} style={{marginTop:"10px", fontSize:"14px", width:"100%", backgroundColor:"red"}} className="nc-Button flex-shrink-0 relative h-auto inline-flex items-center justify-center rounded-full transition-colors border-transparent bg-primary-700 hover:bg-primary-6000 text-primary-50 text-sm sm:text-base font-medium py-3 px-4 sm:py-3.5 sm:px-6">Usuń wideo</button>
              <div style={{display:"flex"}}>
                <button onClick={() =>setMode(true)} style={{marginTop:"10px", fontSize:"14px", width:"50%", backgroundColor:"blue"}} className="nc-Button flex-shrink-0 relative h-auto inline-flex items-center justify-center rounded-full transition-colors border-transparent bg-primary-700 hover:bg-primary-6000 text-primary-50 text-sm sm:text-base font-medium py-3 px-4 sm:py-3.5 sm:px-6">Edytuj</button>
                <button disabled={mode === true ? false: true} onClick={() => onEdit(item)} style={{marginTop:"10px", fontSize:"14px", width:"50%", backgroundColor:"orange"}} className="nc-Button flex-shrink-0 relative h-auto inline-flex items-center justify-center rounded-full transition-colors border-transparent bg-primary-700 hover:bg-primary-6000 text-primary-50 text-sm sm:text-base font-medium py-3 px-4 sm:py-3.5 sm:px-6">Zaaktualizuj</button>
              </div>
              <Input
              type="text"
              onChange={(e) => setNewYoutube(e.target.value)}
              readOnly={mode === true ? false : true}
              placeholder={item?.youtube_id}
              className="mt-1"
            />
              </div>
              </div>
            )})}
      </div>
      <div style={{marginTop:"20px", marginBottom:"20px"}}>
      {/* <ReactPaginate
        nextLabel="następna >"
        onPageChange={handlePageClick}
        pageRangeDisplayed={5}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="< poprzednia"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      /> */}
      </div>
    </div>
  );
};

export default SectionMagazineVideos;
